import React, { ReactNode } from "react";
import { cn } from "../../utils/cn";
import { clamp } from "../../utils/scoring";

interface ScoreInputProps {
    label: string;
    value: number;
    onChange?: (value: number) => void;
    hint?: string;
    icon?: ReactNode;
}

export function ScoreInput({ label, value, onChange, hint, icon }: ScoreInputProps) {
    return (
        <div className="group flex flex-col gap-1.5 p-3 rounded-xl hover:bg-black/5 dark:hover:bg-white/5 transition-colors border border-transparent hover:border-black/5 dark:hover:border-white/5">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    {icon && <span className="text-slate-400 dark:text-slate-500">{icon}</span>}
                    <div>
                        <div className="text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider">{label}</div>
                        {hint && <div className="text-[10px] text-slate-400 dark:text-slate-500 font-medium leading-tight">{hint}</div>}
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <input
                        className="w-16 rounded-lg border-2 border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-2 py-1 text-center text-sm font-bold text-siemens-petrol dark:text-siemens-petrol-light focus:border-siemens-petrol dark:focus:border-siemens-petrol-light focus:ring-0 transition-all"
                        type="number"
                        min={1}
                        max={5}
                        value={value}
                        onChange={onChange ? ((ev) => onChange(clamp(Number(ev.target.value || 1), 1, 5))) : undefined}
                        readOnly={!onChange}
                    />
                    <div className="flex gap-0.5">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div
                                key={i}
                                className={cn(
                                    "w-1 h-3 rounded-full transition-all duration-300",
                                    i <= value ? "bg-siemens-petrol dark:bg-siemens-petrol-light" : "bg-slate-200 dark:bg-slate-700"
                                )}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ScoreInput;
